// pages/machines.js — lifecycle hook for the Machines page
// (data-page="machines"). Created by IA arc PR C as a sweep
// follow-up to PR B''' which moved the My machines + File Path
// Decryption panels here from Settings/Daemon but didn't migrate
// their first-render trigger.
//
// Pre-this-module bug: pages/settings.js's renderSettingsPage()
// called renderMyMachines() + updateDecryptStatus() on Daemon-page
// activation. After the panels moved, the Machines page rendered
// empty ("Loading…" on the machines list) until the user happened
// to navigate to Daemon page first. PR B''' shipped the move but
// not the lifecycle migration — caught in the post-merge sweep.
//
// Pattern mirrors pages/settings.js / pages/account.js /
// pages/team.js: MutationObserver on the section's `.active`
// class flip, start() runs the first render, stop() is currently
// a no-op (the panels don't poll, just react to user input).
import { renderMyMachines, renderLocalMachinePanel } from "../my-machines.js";
import { updateDecryptStatus } from "../daemon-settings.js";

function renderMachinesPage() {
  // Decryption status row — single render is sufficient; the
  // post-import handlers in daemon-discovery.js re-call
  // updateDecryptStatus on every HMAC save/clear/autoimport.
  updateDecryptStatus();
  // Machine list — internal pagination state lives on
  // window._myMachinesPage; we don't reset it here so the user
  // can leave + come back to the same page. Hidden in local-daemon
  // mode (no Supabase session), where renderLocalMachinePanel below
  // fills the daemon-only "This machine" panel instead.
  renderMyMachines();
  // Daemon-only "This machine" panel — the page's primary content in
  // local-daemon mode (where the cloud-only My machines panel above is
  // CSS-hidden). renderLocalMachinePanel bails immediately in cloud
  // modes, so calling it unconditionally here is a cheap no-op there.
  renderLocalMachinePanel();
}

let started = false;

function start() {
  if (started) return;
  started = true;
  renderMachinesPage();
}

function stop() {
  if (!started) return;
  started = false;
}

function bindLifecycle() {
  const section = document.querySelector('section.page[data-page="machines"]');
  if (!section) return;
  if (section.classList.contains("active")) start();
  const obs = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.attributeName !== "class") return;
      if (section.classList.contains("active")) start();
      else stop();
    });
  });
  obs.observe(section, { attributes: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindLifecycle);
} else {
  bindLifecycle();
}
